
import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './rootMutations'
import getters from './rootGetters'
import actions from './rootActions'
import chat from './modules/chat'
import caseCard from './modules/caseCard'
// import editGroup from './modules/editGroup'
// import contacts from './modules/contacts'
// import components from './modules/components'

//全局的state
const state = {
    isLoading : false,
    is_ie : false,
    browser_ver : true,
    is_webkit : false, //是否是webkit内核
    //咨询人数
    chat_count : {
      'no_replay' : 0,
      'replay' : 0,
      'complate' : 0
    },
    //所有分组
    allPatients : {
      all : [],
      device_group : {id : '',name :'',patients : []},
      vip_group:[{id : '',name :'',patients : []},{id : '',name :'',patients : []}],
      other_group : [{id : '',name :'',patients : []}]
    },
    all_patients:[],
    docInfo : {
      name : '',
      sex : '男',
      department : '',
      technical : '',
      skill : '',
      abstract : '',
      hope : '',
      hospital : '',
      hospitals_code : '',
      provinces_area_id : '',
      area_id : ''
    },
    docInfoCopy:{
      account: '',
      name : '',
      sex : '男',
      department : '',
      technical : '',
      skill : '',
      abstract : '',
      hope : '',
      hospital : '',
      hospitals_code : '',
      provinces_area_id : '',
      area_id : ''
    },
    patInfo : {breath : {} , act : {} ,track : {} , c_act : {} , order : {}},
    is_update_doc : true,
    is_update_contacts: true,
    contacts : '',
    //待回复消息的条数
    unReplay : {
      status : true,
      arr : []
    },
    //是否更新待回复条数
    updateUnReplay : false,
    img : [],
    login : false,
    token : '',
    refresh_token : '',
    myorder:{
      review:'',
      reviewed:'',
      complete:''
    },
    researchNumber: '',
    research_back: false,
    research_answer_id: '',
}
Vue.use(Vuex);
export  default new  Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules : {
    chat,
    caseCard
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js